import { useEffect, useState } from 'react'
import { useDeleteSubscriptionMutation } from '../../../graphql/generated/graphql'
import { Subscription } from '../components/bills/Bills'

export const useDeleteSubscription = (
    subscription: Subscription | null,
    onCompleted?: () => void
) => {
    const [removed, setRemoved] = useState<boolean>(false)

    useEffect(() => {
        setRemoved(false)
    }, [subscription])

    const [deleteSubscription, { loading }] = useDeleteSubscriptionMutation({
        variables: { subscriptionId: subscription?.id ?? '' },
        onCompleted(data) {
            setRemoved(data?.deleteSubscription)
            onCompleted?.()
        },
        refetchQueries: ['BillsData'],
        awaitRefetchQueries: true,
    })

    return { deleteSubscription, loading, removed }
}
